module.exports = __webpack_public_path__ + "static/100-64ae498c59c0754125730c8b914f87fc.png";